// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"AutoAssignModal_modalContainer__3gC49"};